var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.49643 8.57946H0V7.11696H2.71071L3.06161 4.88571H0.401786V3.42321H3.27321L3.85714 0H5.56875L4.98482 3.42054H7.81339L8.39732 0H10.0875L9.50357 3.42054H12V4.88304H9.27054L8.94107 7.11429H11.5982V8.57679H8.74554L8.14286 12H6.45268L7.03661 8.57946H4.18661L3.60268 12H1.9125L2.49643 8.57946ZM4.75179 4.88304L4.41964 7.11696H7.24821L7.57768 4.88571H4.75179V4.88304Z",
    fill: "#714fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHash);
export default __webpack_public_path__ + "static/media/hash.04f20bedd2dd678979f89edcb0507b4c.svg";
export { ForwardRef as ReactComponent };